import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LeftOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

const BackButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('buttons.back')}>
      <Button
        type="link"
        icon={
          <LeftOutlined
            style={{
              fill: 'currentColor',
              transition: 'color 0.3s'
            }}
          />
        }
        style={{
          marginLeft: '12px'
        }}
        onClick={() => navigate(-1)}
      />
    </Tooltip>
  );
};

export default BackButton;
